import styled from 'styled-components'

const StyledConnectionSheet = styled.div``

export default StyledConnectionSheet
